import React from 'react';
import esnStar from '../images/esn_logo.png';
const RefreshContent = () => {
    const style = {
        height: '80px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection:'column',
        background: '#3c3b3b',
        color: 'white',
        zIndex:333
    }
    const imgStyle = {
        height: '30px',
        width: '30px'
    }
    const textStyle={
        marginTop:'5px',
        textAlign:'center',
        fontFamily:'KelsonNormal'
    }
    return ( 
        <div style={style}>
            <img className="esn-star rotating" style={imgStyle} src={esnStar} alt=""/>
            <div style={textStyle}>Refreshing!</div>
        </div>
     );
}
 
export default RefreshContent;